const AUTHED_URLS = ['/e/account', '/cart', '/e/cart', '/e/checkout'];
const ACCOUNT_URLS = ['/e/account'];

export const isAuthedUrl = (url: string) => {
    return checkUrlMatch(url, AUTHED_URLS);
};

export const isAccountURL = (url: string) => {
    return checkUrlMatch(url, ACCOUNT_URLS);
};

const checkUrlMatch = (url: string, matchList: string[]) => {
    const authedUrlRe = new RegExp(matchList.map((url) => url + '(?!\\w)').join('|'));
    return authedUrlRe.test(url);
};
